module.exports = __webpack_public_path__ + "static/media/anger.906047b8.png";